import PropTypes from "prop-types"
import { useRecoilState } from "recoil"
import styled from "styled-components"
import { activeArticleTableRowState } from "../../../../../common/store/articleTableStore"
import { attributeIDs } from "../../common/constants"
import { useArticlesFilter } from "../../context/ArticlesFilterContext"
import AttributeValue from "../AttributeValue"
import HighlightedString from "../HighlightedString"
import ArticleCodeCell from "./ArticleCodeCell"

const Td = styled.div`
  display: flex;
  border-right: 1px solid ${({ theme }) => theme.colors.gray[300]};
  overflow: hidden;
  align-items: flex-start;
  background-color: ${({ theme }) => theme.colors.baseWhite};

  &.td--article-code {
    position: sticky !important; //so that react-table doesn't override with inline styles
    left: 0;
    padding: ${({ theme }) => `${theme.sizes.gapSmall}px 0 ${theme.sizes.gapSmall}px ${theme.sizes.gapLarge}px`};

    overflow: visible;
    z-index: 1;
  }

  &.td--article-code.td--article-code--open-menu {
    z-index: ${({ theme }) => theme.zIndex.pdpArticleTableThreeDotsMenu};
  }

  &.td--article-code:not(.td--article-code--single-attribute) {
    flex: none !important;
  }

  &.td--article-attribute {
    padding: ${({ theme }) =>
      `${theme.sizes.gapLarge}px ${theme.sizes.gapLarge}px ${theme.sizes.gapSmall}px ${theme.sizes.gapLarge}px`};
  }

  &.td--unit-value {
    justify-content: flex-end;
  }

  &.td--fraction-value {
    justify-content: flex-end;
  }

  &.td--price-value {
    justify-content: flex-end;
  }
`

const BodyCell = ({
  cell,
  row,
  isArticleCodeCell,
  availableZipOptionsFormData,
  isHighlightedFromSearch,
  resetScroll,
  rowNumberVal,
}) => {
  const [activeArticleTableRow] = useRecoilState(activeArticleTableRowState)

  const articlesFilter = useArticlesFilter()
  const hasReplacementInfo = row.original && row.original.state && row.original.state.replacementFor
  const rowOriginal = row.original
  const columnId = cell.column.id
  const isPrice = cell.column.id === attributeIDs.NET_PRICE || cell.column.id === attributeIDs.GROSS_PRICE

  const displayType = cell.column.displayType

  const displayValueOnly = row.original[`${cell.column.id}_display_value_only`]
  const displayValueFraction = rowOriginal[`${columnId}_display_value_fraction`]
  const value = cell.value

  const content =
    displayType === "fraction" ? displayValueFraction : displayType === "unit" ? displayValueOnly : value ? value : ""

  return (
    <Td
      {...cell.getCellProps()}
      className={`${isArticleCodeCell ? "td--article-code" : "td--article-attribute"}
                     ${hasReplacementInfo && "td--has-replacement-info"}
                     ${displayType === "fraction" && "td--fraction-value"}
                     ${displayType === "unit" && "td--unit-value"}
                     ${isPrice && "td--price-value"}
                     ${row.cells.length === 1 && "td--article-code--single-attribute"}
                     ${activeArticleTableRow === rowNumberVal && "td--article-code--open-menu"}`}
    >
      {isArticleCodeCell ? (
        <ArticleCodeCell
          text={cell.value}
          image={row.original.mainImageUrl}
          state={row.original.state}
          options={{
            zipCadDrawingsLink: row.original.zipCadDrawingsLink,
            zipPhotosDrawingsLink: row.original.zipPhotosDrawingsLink,
            tenderTextId: row.original.tenderTextId,
            accessories: row.original.accessories,
          }}
          availableZipOptionsFormData={availableZipOptionsFormData}
          isHighlightedFromSearch={isHighlightedFromSearch}
          rowNumberVal={rowNumberVal}
          resetScroll={resetScroll}
        />
      ) : (
        <AttributeValue>
          <HighlightedString originalString={content} highlightedString={articlesFilter} />
        </AttributeValue>
      )}
    </Td>
  )
}

export default BodyCell

BodyCell.propTypes = {
  cell: PropTypes.any,
  row: PropTypes.any,
  isArticleCodeCell: PropTypes.bool,
  availableZipOptionsFormData: PropTypes.shape({
    dxf: PropTypes.bool,
    dwg: PropTypes.bool,
    dxf_3D: PropTypes.bool,
    dwg_3D: PropTypes.bool,
    iges_3D: PropTypes.bool,
    step_3D: PropTypes.bool,
    sat_3D: PropTypes.bool,
  }),
  isHighlightedFromSearch: PropTypes.bool,
  resetScroll: PropTypes.func,
  rowNumberVal: PropTypes.number,
}
